import { DataBean } from "../DataBean";

export class SalesOrderState extends DataBean {


    public async getSalesOrderStateConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSalesOrderStateConstants_Number", [args]);
    }


}